export const UPDATE_ALERT = 'alert:updateAlert';

export function updateAlert(message) {
    console.log('updateAlert', message)
    return {
        type: UPDATE_ALERT,
        payload: {
            alert: message
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/alert-actions.js